/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './requestAccountDelete.defs.js'
export { main as default } from './requestAccountDelete.defs.js'
